angular.module('gym.grading').factory('SendGradingEventMessageService', ["$stateParams", "GradingEvents", "TemplateSanitizeService", "bulkMessageService", function($stateParams, GradingEvents, TemplateSanitizeService, bulkMessageService) {
  var bulkMessage, sendGradingEventMessageService;
  bulkMessage = {
    recipients: [],
    recipientList: [],
    groupedRecipients: [],
    template: {}
  };
  sendGradingEventMessageService = {
    get: function() {
      return bulkMessage;
    },
    clear: function() {
      return bulkMessage = {
        recipientList: [],
        recipients: [],
        groupedRecipients: [],
        template: {}
      };
    },
    send: function() {
      var message, recipientIds, template;
      template = TemplateSanitizeService.sanitize(bulkMessage.template);
      recipientIds = _.chain(bulkMessage.recipientList).filter(function(recipient) {
        return recipient.selected;
      }).map(function(recipient) {
        return recipient.id;
      }).value();
      message = {
        contact_comms_recipient_ids: recipientIds,
        template_options: template,
        withoutNamespace: true
      };
      bulkMessageService.clear();
      return GradingEvents.one($stateParams.gradingEventId).all('messages').post(message);
    },
    setContacts: function(contacts) {
      return bulkMessage.recipients = contacts.map(function(c) {
        return {
          id: c.contact_id
        };
      });
    }
  };
  return sendGradingEventMessageService;
}]);
